<template>
  <div>
    <navbar :is-spaced="false" />
    <nuxt-child :site-name="name" />
    <section v-if="$route.path === '/'" class="section is-small">
      <div class="container">
        <loan-application />
      </div>
    </section>
    <lazy-hydrate ssr-only>
      <footer-comp logo="false" />
    </lazy-hydrate>
  </div>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration'

export default {
  layout: 'whitelabel',
  components: {
    LazyHydrate,
    footerComp: () => import( '~/whitelabels/components/footer' ),
    loanApplication: () => import( '~/components/loanApplication' ),
    navbar: () => import( '~/whitelabels/components/navbar' )
  },
  head () {
    const desc = 'KULUTUSLUOTTO 500 - 50.000 € Helposti netistä! LAINAPÄÄTÖS HETI! Laina tunnissa! KULUTUSLUOTTO HELPOSTI! Nopea kulutusluotto! KULUTUSLUOTTO 24/7 NETISTÄ'
    const theme = '#745cf9'
    return {
      title: `${this.name} | Lainahakemus`,
      meta: [
        { hid: 'description', name: 'description', content: desc },
        { hid: 'og:title', name: 'og:title', property: 'og:title', content: this.name },
        { hid: 'og:site_name', name: 'og:site_name', property: 'og:site_name', content: this.name },
        { hid: 'og:description', name: 'og:description', property: 'og:description', content: desc },
        { hid: 'apple-mobile-web-app-title', name: 'apple-mobile-web-app-title', content: this.name },
        { hid: 'theme-color', name: 'theme-color', content: theme }
      ],
      link: [{ rel: 'icon', type: 'image/x-icon', href: require( '~/assets/whitelabels/kulutusluotto24/favicon.png' ) }]
    }
  },
  data () {
    return {
      name: 'Kulutusluotto24',
      domain: 'kulutusluotto24.fi'
    }
  }
}
</script>

<style lang="scss">
@import "~assets/whitelabels/scss/_variables.scss";

$wl-primary: #745cf9;
$wl-body-background: linear-gradient(to bottom, #f3f3f5 1%, #fff 100%);

$wl-navbar-background: #fff;
$wl-navbar-height: 7.5rem;
$wl-navbar-logo-height: 4.75rem;

$wl-slider-handle-border: 2px solid white;

$wl-footer-color: white;
$wl-footer-background: #0e1015;

@import "~assets/whitelabels/scss/styles.scss";

.whitelabel.kulutusluotto24 {
  @include whitelabel;
}
</style>
